import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getStorage } from "./storage";

export const checkEmailExistInStorage = () => {
  const storage = getStorage();
  return storage.userName;
};

function PublicRoute({ component: Component, ...rest }) {
  let { isAuthenticated } = rest;

  if (!isAuthenticated) {
    isAuthenticated = checkEmailExistInStorage();
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Redirect
            to={{
              pathname: "/configurations",
              // state: { from: props.location },
            }}
          />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
}

export default PublicRoute;
